import "./style.css";
import layout from "./layout.html";

export default class LunchAperitifIntro {
  static selector = ".lunch-aperitif__intro";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
